import header from './components/header';


export default () => {
  header();
}